import { render, staticRenderFns } from "./CampaignListTable.vue?vue&type=template&id=c37efde4&scoped=true"
import script from "./CampaignListTable.vue?vue&type=script&lang=js"
export * from "./CampaignListTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignListTable.vue?vue&type=style&index=0&id=c37efde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37efde4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VPagination,VProgressLinear})
